<!-- Вывод компонентов роутинга -->
<router-outlet/>
<!-- / Вывод компонентов роутинга -->
